import { defineMessages } from 'react-intl';

export const productCategoryNavigationMobileV2Messages = defineMessages({
  header: {
    id: 'filtersV2.category.navigation.header',
    defaultMessage: 'Kategorie',
  },
  allCategories: {
    id: 'filtersV2.category.navigation.allCategories',
    defaultMessage: 'Alle Kategorien',
  },
  previousCategory: {
    id: 'filtersV2.category.navigation.previousCategory',
    defaultMessage: 'Vorherige Kategorie: {name}',
  },
  allIn: {
    id: 'filtersV2.category.navigation.allIn',
    defaultMessage: 'Alles in {name}',
  },
  helperSingle: {
    id: 'filtersV2.category.navigation.helperSingle',
    defaultMessage: 'Du kannst hier nur eine Auswahlmöglichkeit treffen.',
  },
  submit: {
    id: 'filtersV2.category.navigation.submit',
    defaultMessage: 'Übernehmen',
  },
  cancel: {
    id: 'filtersV2.category.navigation.cancel',
    defaultMessage: 'Abbrechen',
  },
  drillIntoCategory: {
    id: 'filtersV2.category.navigation.drillIntoCategory',
    defaultMessage: 'Unterkategorien von {name} anzeigen',
  },
});
